export default __webpack_public_path__ + "6ac9ea6d57d15530746d16f8856fb6f4.svg";